<template>
  <div class="order">
    <ul class="order-bar">
      <li class="order-bar-item" :class="{ active: orderType == 'draft' }" @click="changeType('draft')">Draft</li>
      <li class="order-bar-item" :class="{ active: orderType == 'unsent' }" @click="changeType('unsent')">Upcoming</li>
      <li class="order-bar-item" :class="{ active: orderType == 'processing' }" @click="changeType('processing')">
        Processing
      </li>
      <li class="order-bar-item" :class="{ active: orderType == 'completed' }" @click="changeType('completed')">
        Completed
      </li>
    </ul>
    <div class="order-list">
      <div v-for="order in orders" :key="order.orderNum" class="order-item">
        <div class="title">
          <div class="date">
            <img src="../../assets/imgs/order-date.png" />
            <span>{{ order.orderDateTime }}</span>
            <span class="order-num">Order#: {{ order.orderNum }}</span>
          </div>
          <div class="title-control">
            <span v-if="order.showCancel" class="btn cancel" @click="cancelOrder(order.orderNum)">Cancel</span>
            <span v-if="orderType != 'draft'" class="btn" @click="orderDetail(order.orderNum)">View details ></span>
            <div v-else-if="order.showPay" style="margin-left: 20px;">
              <mk-button type="primary" @click="continueOrder(order.orderNum)">Pay</mk-button>
            </div>
            <div v-else>
              <span class="btn" @click="continueOrder(order.orderNum)">Continue ></span>
            </div>
          </div>
        </div>
        <div class="order-content">
          <div v-if="order.showUpcoming || order.showSending || order.showStoring" class="order-content-row">
            <div class="order-from">
              <div>
                <span class="name">
                  <img style="width: 13px; height: 17px; margin: 4px 5px 0 0" src="../../assets/imgs/location.png" />
                  <p>{{ order.sendCityState }}</p>
                </span>
                <p class="order-tip order-tip-left">{{ order | orderTip('upcomingNum') }}</p>
              </div>
              <div>
                <span class="arrow"></span>
                <p class="order-tip order-tip-center">{{ order | orderTip('sendingNum') }}</p>
              </div>
              <div>
                <span class="name to">
                  <img style="width: 14px; height: 14px; margin: 5px 5px 0 0" src="../../assets/imgs/house.png" />
                  <p>{{ order.kiteHouse }}</p>
                </span>
                <p class="order-tip order-tip-right">{{ order | orderTip('storingNum') }}</p>
              </div>
            </div>
          </div>
          <div v-if="order.showSigned || order.showBacking" class="order-content-row">
            <div class="order-from">
              <div>
                <span class="name">
                  <img style="width: 14px; height: 14px; margin: 5px 5px 0 0" src="../../assets/imgs/house.png" />
                  <p>{{ order.kiteHouse }}</p>
                </span>
                <p class="order-tip order-tip-left"></p>
              </div>
              <div>
                <span class="arrow"></span>
                <p class="order-tip order-tip-center">{{ order | orderTip('backingNum') }}</p>
              </div>
              <div>
                <span class="name to">
                  <img style="width: 13px; height: 17px; margin: 4px 5px 0 0" src="../../assets/imgs/location.png" />
                  <p>{{ order.backCityState }}</p>
                </span>
                <p class="order-tip order-tip-right">{{ order | orderTip('signedNum') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Empty v-show="orders.length === 0" />
    </div>
    <div class="page">
      <i-page
        :total="total"
        :page-size="pageSize"
        :current.sync="page"
        show-sizer
        @on-page-size-change="onPageSizeChange"
        @on-change="onChange"
      />
    </div>
    <i-spin v-if="loading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { API } from '../../net/http';
import Empty from './components/Empty';
import MkButton from '@/components/button/MkButton.vue';

export default {
  components: {
    MkButton,
    Empty,
  },
  data() {
    return {
      orderType: 'draft',
      total: 1,
      pageSize: 20,
      page: 1,
      orders: [],
      loading: false,
    };
  },
  mounted() {
    this.search();
  },
  beforeRouteEnter(to, form, next) {
    let orderType = form.query.ordertype;
    next(vm => {
      if (orderType) {
        vm.changeType(orderType);
      }
    });
  },
  methods: {
    changeType(type) {
      this.orders = [];
      this.orderType = type;
      this.page = 1;
      this.total = 1;
      this.search();
    },
    onPageSizeChange(pageSize) {
      if (pageSize) {
        this.pageSize = pageSize;
        this.search();
      }
    },
    onChange() {
      this.search();
    },
    search() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.searchOrder({
        status: this.orderType,
        size: this.pageSize,
        page: this.page,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.total = Number(res.totalData);
            this.page = Number(res.page);
            // this.pageSize = Number(res.size);
            this.orders = res.data;
          } else {
            this.orders = [];
            this.$Message.error({
              content: res.message,
              dutation: 3,
            });
          }
        })
        .catch(() => {
          this.orders = [];
          this.loading = false;
        });
    },
    orderTipType(order) {
      if (order.showUpcoming) {
        return 'order-tip-left';
      } else if (order.showSending) {
        return 'order-tip-center';
      } else if (order.showStoring) {
        return 'order-tip-right';
      }
    },
    orderDetail(orderNum) {
      this.$router.push(`/send/${orderNum}?ordertype=${this.orderType}`);
    },
    cancelOrder(orderNum) {
      this.$Modal.confirm({
        title: 'Are you sure cancel ?',
        cancelText: 'NO',
        okText: 'YES',
        onCancel() {},
        onOk: () => {
          this.loading = true;
          this.$post(API.orderMainCancel, {
            orderNum: orderNum,
          })
            .then(res => {
              this.loading = false;
              if (res.success) {
                this.search();
              } else {
                this.$Message.warning(res.message);
              }
            })
            .catch(() => {
              this.loading = false;
            });
        },
      });
    },
    continueOrder(orderNum) {
      this.orderDetail(orderNum);
    },
    ...mapActions('order', ['searchOrder']),
  },
  filters: {
    orderTip(order, type) {
      if (type === 'upcomingNum' && order.showUpcoming) {
        return `${order.upcomingNum} item${order.upcomingNum > 1 ? 's' : ''} to ship`;
      } else if (type === 'sendingNum' && order.showSending) {
        return `${order.sendingNum} item${order.sendingNum > 1 ? 's' : ''} in transit`;
      } else if (type === 'storingNum' && order.showStoring) {
        return `${order.storingNum} item${order.storingNum > 1 ? 's' : ''} in storage`;
      } else if (type === 'backingNum' && order.showBacking) {
        return `${order.backingNum} item${order.backingNum > 1 ? 's' : ''} in returning`;
      } else if (type === 'signedNum' && order.showSigned) {
        return `${order.signedNum} item${order.signedNum > 1 ? 's' : ''} delivered`;
      }
      return '';
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.order {
  min-height: 856px;
  padding: 30px;
  .order-bar {
    width: 100%;
    overflow: hidden;
    .order-bar-item {
      .font-regular;
      cursor: pointer;
      float: left;
      width: 140px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      color: @app-black-color;
      font-size: 20px;
      font-weight: 400;
      margin-right: 30px;
      text-align: center;
      &.active {
        background: @app-color;
        color: #fff;
      }
    }
  }
  .order-list {
    margin-top: 36px;
    position: relative;
    .tips {
      .font-light;
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      font-weight: 300;
      color: @app-black-color;
      padding-bottom: 10px;
    }
    .order-item {
      margin-top: 18px;
      border: 1px solid #eeeff0;
      &:first-child {
        margin-top: 0px;
      }
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 24px;
        height: 56px;
        background: #f7f8fc;
        border-radius: 4px 4px 0px 0px;
        .date {
          display: flex;
          flex-direction: row;
          align-items: center;
          .order-num {
            .font-light;
            color: @app-black-color;
            font-size: 16px;
            font-weight: 300;
            padding-left: 46px;
          }
          img {
            width: 16px;
            height: 18px;
            margin-top: -3px;
          }
          span {
            .font-light;
            padding-left: 10px;
            font-size: 16px;
            font-weight: 300;
            color: @app-black-color;
          }
        }
        .title-control {
          flex: 1;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: flex-end;
          .btn {
            color: @app-blue-color;
            margin-left: 20px;
            &.cancel {
              color: @app-body-color;
            }
          }
        }
      }
      .order-content {
        .order-content-row {
          height: 126px;
          padding: 0 110px;
          border-bottom: 1px solid @app-placeholder-color;
          &:last-child {
            border-bottom: 0px solid transparent;
          }
        }
        .order-from {
          padding-top: 39px;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          //align-items: center;
          .name {
            .font-regular;
            flex: 1;
            font-size: 18px;
            font-weight: 400;
            color: @app-black-color;
            white-space: nowrap;
            text-align: right;
            display: flex;
            //justify-content: flex-end;
            &.to {
              text-align: left;
            }
          }
          .arrow {
            width: 250px;
            background-color: @app-placeholder-color;
            height: 3px;
            //margin-top: 12px;
            margin: 0 36px;
            display: inline-block;
            position: relative;
            &:after {
              content: ' ';
              display: inline-block;
              height: 3px;
              position: absolute;
              right: 0;
              top: -4px;
              width: 10px;
              background-color: @app-placeholder-color;
              transform: rotate(45deg);
            }
          }
        }
        .tip-wrap {
          display: flex;
          flex-direction: row;
          align-items: center;
          .order-tip {
            flex: 1;
          }
        }
        .order-tip {
          .font-light;
          padding-top: 10px;
          font-size: 18px;
          font-weight: 300;
          color: #ffaa85;
          &.order-tip-center {
            text-align: center;
          }
          &.order-tip-right {
            text-align: center;
            position: absolute;
          }
        }
      }
    }
  }
  .page {
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
<style>
.ivu-select-single .ivu-select-selection,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 34px;
  line-height: 34px;
}
.ivu-page-options-sizer {
  margin-right: 0;
}
</style>
